module.exports = __webpack_public_path__ + "img/ealigner-panorama-img.4362d041.png";